module.exports = __webpack_public_path__ + "img/icon_fb.svg?de70380de170c143ef6d061a08fb5daf";